import React, { useEffect, useContext, useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import GroupsList from '../../../AddToGroupsPanel/_partials/GroupsList';
import { useAddToGroupFlow } from '../../../AddToGroupsPanel/useAddToGroupFlow';
import FolderList from '../../../AddToGroupsPanel/_partials/FolderList';
import SelectedGroupHeader from './SelectedGroupHeader';
import GroupTabs from './GroupTabs';
import GroupSearchInput from './GroupSearchInput';
import s from './AddToGroupPopup.scss';
var AddToGroupPopup = function (_a) {
    var deviation = _a.deviation, className = _a.className, actionbarType = _a.actionbarType, initGroupsPanel = _a.initGroupsPanel, addToGroupFolder = _a.addToGroupFolder, hasOnlyOneChunkOfGroupsToLoad = _a.hasOnlyOneChunkOfGroupsToLoad, hasNoGroups = _a.hasNoGroups, onClose = _a.onClose;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useAddToGroupFlow(), selectGroup = _b.selectGroup, selectedGroup = _b.selectedGroup, resetSelectedGroup = _b.resetSelectedGroup, selectedSubmissionType = _b.selectedSubmissionType, selectSubmissionType = _b.selectSubmissionType, filterValue = _b.filterValue, onFilterInputChange = _b.onFilterInputChange;
    useEffect(function () {
        initGroupsPanel();
    }, [initGroupsPanel]);
    var onFolderSelected = useCallback(function (folderId) {
        if (!selectedGroup) {
            return;
        }
        addToGroupFolder(deviation, selectedGroup, {
            groupId: selectedGroup.userId,
            type: selectedSubmissionType,
            folderId: folderId,
        }, actionbarType);
        setTimeout(function () {
            onClose && onClose();
        }, 1000); // to show state change (folder becoming checked in the list) for the user
    }, [
        actionbarType,
        addToGroupFolder,
        deviation,
        onClose,
        selectedGroup,
        selectedSubmissionType,
    ]);
    var showTabs = !!selectedGroup;
    var showSearch = !selectedGroup && !hasNoGroups && hasOnlyOneChunkOfGroupsToLoad;
    var preamble = (React.createElement(React.Fragment, null,
        showTabs && (React.createElement(GroupTabs, { selectedSubmissionType: selectedSubmissionType, selectSubmissionType: selectSubmissionType, className: s['tabs'] })),
        showSearch && (React.createElement(GroupSearchInput, { className: s['filter-input'], filterValue: filterValue, onFilterInputChange: onFilterInputChange }))));
    var content = (React.createElement(React.Fragment, null,
        selectedGroup === undefined && (React.createElement(GroupsList, { filterValue: filterValue, onSelect: selectGroup })),
        selectedGroup && (React.createElement(FolderList, { deviationId: deviation.deviationId, groupId: selectedGroup.userId, submissionType: selectedSubmissionType, onFolderSelected: onFolderSelected }))));
    if (isMobile) {
        return (React.createElement(DSModal, { isOpen: true, heading: selectedGroup ? (React.createElement(SelectedGroupHeader, { group: selectedGroup, resetSelectedGroup: resetSelectedGroup })) : (React.createElement(React.Fragment, null, t('addToGroupPopup.title'))), preamble: preamble, className: c(s['root'], className), contentClassName: s['content-wrapper'], withScrollableContentWrapper: true, onRequestClose: onClose }, content));
    }
    return (React.createElement(DSPopover, { heading: selectedGroup ? selectedGroup.username : t('addToGroupPopup.title'), className: c(s['root'], className), contentClassName: s['content-wrapper'], preamble: preamble, content: content, onCloseClick: onClose, onBackClick: selectedGroup ? resetSelectedGroup : undefined }));
};
AddToGroupPopup.displayName = 'AddToGroupPopup';
export default AddToGroupPopup;
//# sourceMappingURL=AddToGroupPopup.js.map